import { NavItem, NavItemAccessor } from '@billy/design-system'
import { TFunction } from 'i18next'

import { ContactsTableActionType } from '../../../enums/ContactsTableActionType'

export const getContactsTableStaticActions = (
  contactId: string,
  t: TFunction,
): NavItem<ContactsTableActionType | 'separator'>[] => [
  {
    children: t('contacts.list.actions.edit'),
    iconLeft: 'squarePen',
    id: `${contactId}-edit`,
    value: ContactsTableActionType.Edit,
    variant: 'primary',
  },
  {
    accessor: NavItemAccessor.Separator,
    children: null,
    id: `${contactId}-separator`,
    value: 'separator',
  },
  {
    children: t('contacts.list.actions.delete'),
    iconLeft: 'trash',
    id: `${contactId}-delete`,
    value: ContactsTableActionType.Delete,
    variant: 'danger',
  },
]
